import axios from 'axios';
import authToken from 'js/library/utils/API/authToken';
import cfac22 from '../cfac22';

export default function deleteUser(uid) {
  return new Promise((resolve, reject) => {
    authToken(uid)
      .then((token) => {
        axios
          .delete(cfac22('API_HOST_V2') + '/users', {
            headers: { authorization: 'Bearer ' + token, 'Full-Url': window.location.href },
          })
          .then((result) => {
            // console.log("RESULTADO API GETPOWERBI ===>: ", result);
            resolve(result.data);
          })
          .catch((error) => {
            //console.log("ERRO API POWERBI ===>: ", error);
            return reject(error.response.data);
          });
      })
      .catch((error) => {
        // console.log("ERROR_TOKEN ===>", error);
        reject(error.response.data);
      });
  });
}
